module.exports = __webpack_public_path__ + "static/media/task2Planet1.7e1667d0.png";